export const ROUTES = {
    ROOT: '/',

    // Pre-identity
    PRE_IDENTITY: '/pre-identity-check',
    TWO_FACTOR_AUTHENTICATION: '/pre-identity-check/2fa',
    TWO_FACTOR_OTP: '/pre-identity-check/2fa/verify/otp',
    RISK_ASSESSMENT: '/pre-identity-check/risk-assessment',

    // Home
    VERIFICATION: '/verification',
    EDUCATION: '/education',
    EMPLOYMENT: '/employment',
    PROFESSIONAL_LICENSE: '/professional-license',
    THANK_YOU: '/thank-you',

    // Verification sub-routes
    VERIFICATION_ATTEMPTS_EXHAUSTED: '/verification/attempts-exhausted',
    KBA_QUIZ: '/verification/kba',
    KBA_RESULT: '/verification/kba/result',
    KBA_FAILED: '/verification/kba/failed',
    BANK: '/verification/bank',
    BANK_CONNECT: '/verification/bank/connect',
    BANK_SUCCESS: '/verification/bank/success',
    BANK_FAILED: '/verification/bank/failed',
    DEVICE_LINKS: '/verification/links',
    ID_FAILED: '/verification/idFailed',
    ID_SIDES_FAILED: '/govtid/error/id_sides_failed',

    // GovtId
    GOVT_ID_VERIFICATION: '/govtid',
    MOBILE_CAPTURE: '/govtid/capture/camera',
    CAPTURE_SELFIE: '/govtid/capture/selfie',
    GOVT_ID_PHOTO_CONFIRM: '/govtid/photo/confirm',
    GOVT_ID_RESULTS: '/govtid/results',
    GOVT_ID_RESULT_DEFAULT: '/govtid/results/default',
    GOVT_ID_RESULT_MEDICARD: '/govtid/results/medicard',
    GOVT_ID_ERROR: '/govtid/error',
    GOVT_ID_ID_TIMEOUT: '/govtid/idTimeout',
    GOVT_ID_COMPLETE_FLOW: '/govtid/complete/flow',

    // GovtId v2 — Regula document capture and AWS liveness. Runs alongside the tree above; the
    // error, timeout and attempts screens are shared and keep their existing paths.
    GOVT_ID_V2: '/govtid/v2',
    GOVT_ID_V2_CAPTURE_CAMERA: '/govtid/v2/capture/camera',
    GOVT_ID_V2_CAPTURE_NEXT: '/govtid/v2/capture/next', // Between-sides screen in manual mode.
    GOVT_ID_V2_PHOTO_CONFIRM: '/govtid/v2/photo/confirm',
    GOVT_ID_V2_CAPTURE_SELFIE: '/govtid/v2/capture/selfie',
    GOVT_ID_V2_CAPTURE_SELFIE_LIVENESS: '/govtid/v2/capture/selfie/liveness',
    GOVT_ID_V2_RESULTS: '/govtid/v2/results',
    // v2's own copies of shared error screens, so they ship with the flow.
    GOVT_ID_V2_ERROR_SDK_FAILED: '/govtid/v2/error/sdk/failed',
    GOVT_ID_V2_ERROR_CAMERA_FAILED: '/govtid/v2/error/camera/failed',

    // GovtId errors
    GOVT_ID_ERROR_SELFIE_CAPTURE_FAILED: '/govtid/error/selfie/capture/failed',
    GOVT_ID_ERROR_SELFIE_CAMERA_FAILED: '/govtid/error/selfie/camera/failed',
    GOVT_ID_ERROR_SELFIE_TIMEOUT: '/govtid/error/selfie/timeout',
    GOVT_ID_ERROR_SELFIE_DEFAULT: '/govtid/error/selfie/default',
    GOVT_ID_ERROR_INVALID_ID: '/govtid/error/invalid_id',
    GOVT_ID_ERROR_INVALID_DOB: '/govtid/error/invalid_date_of_birth',
    GOVT_ID_ERROR_INVALID_DOCUMENT_TYPE: '/govtid/error/invalid_document_type',
    GOVT_ID_ERROR_DEFAULT: '/govtid/error/default',
    GOVT_ID_ERROR_LOW_RESOLUTION: '/govtid/error/lowresolution',
    GOVT_ID_ERROR_MOBILE_ONLY: '/govtid/error/mobileonly',
    GOVT_ID_ERROR_ID_EXPIRED: '/govtid/error/idexpired',
    GOVT_ID_ERROR_COUNTRY_MISMATCH: '/govtid/error/country_mismatch',
    GOVT_ID_ERROR_UNSUPPORTED_BROWSER: '/govtid/error/unsupported_browser',
    GOVT_ID_ERROR_IN_APP_BROWSER: '/govtid/error/in_app_browser',
    GOVT_ID_ERROR_SDK_FAILED: '/govtid/error/sdk/failed',
    GOVT_ID_ERROR_CAMERA_FAILED: '/govtid/error/camera/failed',
    GOVT_ID_ERROR_TAMPER_RESULT_FAILED: '/govtid/error/tamper-result/failed',
    GOVT_ID_ERROR_FRONT_NOT_READABLE: '/govtid/error/front_not_readable',
    GOVT_ID_ERROR_BACK_NOT_READABLE: '/govtid/error/back_not_readable',
    GOVT_ID_ERROR_DATA_MISMATCH: '/govtid/error/data_mismatch',
    GOVT_ID_ERROR_LIVENESS_FAILED: '/govtid/error/liveness_failed',
    GOVT_ID_ERROR_AUTHENTICITY_FAILED: '/govtid/error/authenticity_failed',
    GOVT_ID_ERROR_INVALID_NAME: '/govtid/error/invalid_name',
    GOVT_ID_ERROR_BACK_SIDE_REQUIRED: '/govtid/error/back_side_required',

    // Reauthenticate
    REAUTHENTICATE: '/reauthenticate',
    REAUTHENTICATE_LINK: '/reauthenticate/link',
    REAUTHENTICATE_CAPTURE_SELFIE: '/reauthenticate/capture/selfie',
    REAUTHENTICATE_CAPTURE_SELFIE_LIVENESS: '/reauthenticate/capture/selfie/liveness',
    REAUTHENTICATE_SELFIE_FAILURE: '/reauthenticate/selfie/failure',
    REAUTHENTICATE_VERIFY_CODE: '/reauthenticate/verify/code',
    REAUTHENTICATE_CODE_FAILURE: '/reauthenticate/code/failure',
    REAUTHENTICATE_RESULT: '/reauthenticate/result',
    REAUTHENTICATE_SELFIE_TIMEOUT: '/reauthenticate/selfie/timeout',
    REAUTHENTICATE_IN_APP_BROWSER: '/reauthenticate/error/in_app_browser',
};

export const supportRoutes = [
    {
        path: 'email-or-phone',
        title: 'No Email or Phone Access',
        message:
            'Don’t have access to this email or phone number? Please contact your administrator for further steps.',
        btnText: 'Back',
    },
    {
        path: 'email',
        title: 'No Email Access',
        message:
            'Don’t have access to this email? Please contact your administrator for further steps.',
        btnText: 'Back',
    },
    {
        path: 'phone',
        title: 'No Phone Number Access',
        message:
            'Don’t you have access to this phone number? Please contact your administrator for further steps.',
        btnText: 'Back',
    },
    {
        path: 'session-expired',
        title: 'Session Expired',
        message: 'Unfortunately your previous session has expired. Please restart your session.',
        btnText: 'Retry',
    },
    {
        path: 'attempts-exhausted',
        title: 'Attempts Exhausted!',
        message:
            'Unfortunately you have run out of attempts. Please contact your administrator for further steps.',
    },
];

export const editContactRoutes = [
    {
        path: 'email',
        title: 'Edit Email',
        subTitle:
            'Please confirm your email below to proceed with Two Factor Authentication (2FA).',
        inputLabel: 'Email *',
        inputName: 'email',
    },
    {
        path: 'phone',
        title: 'Edit Phone Number',
        subTitle:
            'Please confirm your phone number below to proceed with Two Factor Authentication (2FA).',
        inputLabel: 'Phone Number *',
        inputName: 'phoneNumber',
    },
];

export const CONTACT_SUPPORT_SUB_ROUTES = {
    EMAIL_OR_PHONE: 'email-or-phone',
    EMAIL: 'email',
    PHONE: 'phone',
};
